export interface NoticeItem {
    [key: string]: any;

    title: string;

    list: any[];

    emptyText?: string;

    emptyImage?: string;
}
